import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import Card from 'components/Card';
import { documentsCardData } from 'sections/Resources/FreightTemplates/CommercialInvoice/data';
import { DocumentCard } from 'sections/Resources/FreightTemplates/CommercialInvoice/types';
import styles from 'sections/Resources/FreightTemplates/CommercialInvoice/components/SectionDocuments/SectionDocuments.module.scss';

const cn = classNames.bind(styles);

const SectionDocuments = (): ReactElement => {
  const cards = documentsCardData.map((card: DocumentCard) => {
    return (
      <Card className={cn('card')} key={card.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__heading-box')}>
            <img
              className={cn('card__icon')}
              src={`/images/pages/Resources/FreightTemplates/${card.iconName}`}
              alt='file'
            />
            <h4 className={cn('card__heading')}>
              {card.url
                ?
                <Link href={card.url as Route}>{card.heading}</Link>
                :
                card.heading
              }
            </h4>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <a
              className={cn('card__button')}
              href={`/download/Resources/FreightTemplates/${card.fileName}.docx`}
            >
              Download (Word)
            </a>
            <a
              className={cn('card__button')}
              href={`/download/Resources/FreightTemplates/${card.fileName}.pdf`}
              target='_blank'
            >
              Download (PDF)
            </a>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('documents')}>
      <div className={cn('container')}>

        <h2 className={cn('documents__heading')}>
          You may also need
        </h2>

        <div className={cn('documents__cards')}>
          {cards}
        </div>
      </div>

    </section>
  );
};

export default SectionDocuments;